import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const BytesList = lazy(() => import('../../pages/bytes'));
const AddBulkBytes = lazy(() => import('../../pages/bytes/AddBulk'));
const AddBytes = lazy(() => import('../../pages/bytes/Add'));
const EditBytes = lazy(() => import('../../pages/bytes/Edit'));
const AddCatalogItem = lazy(() => import('../../pages/catalog-items/Add'));
const EditCatalogItem = lazy(() => import('../../pages/catalog-items/Edit'));

const BytesRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/`} component={BytesList} />
            <Route exact path={`${path}/add-new-bulk`} component={AddBulkBytes} />
            <Route exact path={`${path}/add-new`} component={AddBytes} />
            <Route exact path={`${path}/catalog/add-new`} component={AddCatalogItem} />
            <Route exact path={`${path}/catalog/:id`} component={EditCatalogItem} />
            <Route exact path={`${path}/:id`} component={EditBytes} />
        </Switch>
    );
};

export default BytesRoute;
